import { endpoints, baseurl } from "../Utils/Constants";

const authHeaders = (token) => ({
  "ngrok-skip-browser-warning": "true",
  Authorization: `Bearer ${token}`,
});

const get = async (token, endpoint, params, signal) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) value.forEach((item) => qs.append(key, item));
    else if (value !== undefined && value !== null && value !== "") qs.set(key, value);
  });
  const response = await fetch(`${baseurl}${endpoint}?${qs.toString()}`, { method: "GET", headers: authHeaders(token), signal });
  return response.json();
};

/** List page — one row per payer with its network file counts. */
export const getFeeSchedulePayers = async (token, signal) => {
  const url = `${baseurl}${endpoints.GET_FEE_SCHEDULE_PAYERS}`;
  const response = await fetch(url, { method: "GET", headers: authHeaders(token), signal });
  return response.json();
};

/** Networks, ingestion status and the payer's billing codes — metadata only. */
export const getFeeScheduleOverview = (token, insuranceId, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_OVERVIEW, { insurance_id: insuranceId }, signal);

/** Employer plans that use one network. */
export const getFeeScheduleNetworkPlans = (token, insuranceId, sourceFileId, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_NETWORK_PLANS, { insurance_id: insuranceId, source_file_id: sourceFileId }, signal);

/** Top and bottom paid providers for a code in a 5-digit zip. filters: { cptCode, zip, modifier, setting, npi } */
export const getFeeScheduleZipRates = (token, insuranceId, filters, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_ZIP_RATES, {
    insurance_id: insuranceId,
    cpt_code: filters.cptCode,
    zip: filters.zip,
    modifier: filters.modifier,
    setting: filters.setting,
    npi: filters.npi,
  }, signal);

/** Every code this payer pays one NPI. */
export const getFeeScheduleProviderRates = (token, insuranceId, npi, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_PROVIDER_RATES, { insurance_id: insuranceId, npi }, signal);

/** Rate card for the logged-in provider's NPI. */
export const getFeeScheduleMyRateCard = (token, insuranceId, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_MY_RATE_CARD, { insurance_id: insuranceId }, signal);

/** Every provider specialty in the loaded fee schedules. */
export const getFeeScheduleSpecialties = (token, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_SPECIALTIES, {}, signal);

/** Providers of one specialty in one state, ranked by rate for one code. */
export const getFeeScheduleSpecialtyRates = (token, insuranceId, filters, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_SPECIALTY_RATES, {
    insurance_id: insuranceId,
    specialty: filters.specialty,
    state: filters.state,
    cpt_code: filters.cptCode,
    modifier: filters.modifier,
    setting: filters.setting,
  }, signal);

/** Providers and shared contract rates for one TIN. */
export const getFeeScheduleGroupRates = (token, insuranceId, tin, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_GROUP_RATES, { insurance_id: insuranceId, tin }, signal);

/** Rates with a real expiration date. */
export const getFeeScheduleExpiringRates = (token, insuranceId, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_EXPIRING_RATES, { insurance_id: insuranceId }, signal);

/** Placeholder prices and NPIs the national registry does not recognise. */
export const getFeeScheduleDataQuality = (token, insuranceId, signal) =>
  get(token, endpoints.GET_FEE_SCHEDULE_DATA_QUALITY, { insurance_id: insuranceId }, signal);
